import firebase from '@firebase/app'
import 'firebase/firestore'
import 'firebase/firebase-auth'
import 'firebase/storage'

var config = {
    apiKey: "AIzaSyDI2vSkmLMOVBcT4M64TcyWZOnCkBDdKd4",
    authDomain: "pg-project-672f4.firebaseapp.com",
    databaseURL: "https://pg-project-672f4.firebaseio.com",
    projectId: "pg-project-672f4",
    storageBucket: "pg-project-672f4.appspot.com",
    messagingSenderId: "336011346030",
    appId: "1:336011346030:web:7c5884c36c255ecc4be67f",
    measurementId: "G-GWMPY39VSY"
  }

  
  


  const fb = firebase.initializeApp(config)
  var db = firebase.firestore();
  //Timestamp = firebase.firestore.Timestamp;
  //const db= firebase.firestore()
  
  export{fb,db}
  
  
